module.exports = __webpack_public_path__ + "img/brain_white.668b21ee.svg";